import { render, staticRenderFns } from "./PurchaseAids.vue?vue&type=template&id=21ee7f5a&scoped=true&"
import script from "./PurchaseAids.vue?vue&type=script&lang=js&"
export * from "./PurchaseAids.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAids.vue?vue&type=style&index=0&id=21ee7f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee7f5a",
  null
  
)

export default component.exports